import { Controller } from '@hotwired/stimulus'

const TRANSPARENT_PIXEL = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='

export default class ImageFallbackController extends Controller {
  static values = { fallback: String }

  connect () {
    this.originalSource = this.element.currentSrc || this.element.src
    this.originalAlt = this.element.alt
    this.retryCount = 0
    this.retryTimer = null
    this.retrying = false

    if (this.element.complete) {
      if (this.element.naturalWidth === 0) {
        this.replace()
      } else {
        this.loaded()
      }
    }
  }

  disconnect () {
    clearTimeout(this.retryTimer)
  }

  replace () {
    if (!this.hasFallbackValue || this.element.src === this.fallbackValue) return
    if (this.retryTimer) return

    this.showSkeleton()
    this.scheduleRetry()
  }

  scheduleRetry () {
    if (this.retryTimer) return

    if (this.retryCount >= 3) {
      this.showFallback()
      return
    }

    this.retryCount += 1
    const delay = 500 * (2 ** (this.retryCount - 1))

    this.retryTimer = setTimeout(() => {
      this.retryTimer = null
      if (!this.element.isConnected) return

      const retryImage = new globalThis.Image()

      retryImage.onload = () => {
        if (!this.element.isConnected) return

        this.element.classList.remove('profile-image-skeleton')
        this.element.alt = this.originalAlt
        this.retrying = false
        this.element.src = this.originalSource
        this.retryCount = 0
      }

      retryImage.onerror = () => {
        if (this.retryCount >= 3) {
          this.showFallback()
        } else {
          this.scheduleRetry()
        }
      }

      // Keep the exact URL because query changes invalidate signed S3 URLs.
      retryImage.src = this.originalSource
    }, delay)
  }

  loaded () {
    if (this.retrying) return
    this.element.classList.remove('profile-image-skeleton')
    if (this.element.src !== this.fallbackValue) this.retryCount = 0
  }

  showSkeleton () {
    this.retrying = true
    this.element.alt = ''
    this.element.src = TRANSPARENT_PIXEL
    this.element.classList.add('profile-image-skeleton')
  }

  showFallback () {
    this.retrying = false
    this.element.alt = ''
    this.element.src = TRANSPARENT_PIXEL
    this.element.classList.add('profile-image-skeleton')
  }
}
